import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Deck } from "./records";

const slice = createEntitySlice<Deck>({
  name: "roomDecks",
});

export const { actions, reducer } = slice;
